import React, { memo, useMemo } from 'react';
import { useCurrentWorkspace } from '@hooks/workspace';
import MultiSelectFilter, {
  SHOW_ALL_KEY
} from '@components/Approval/MultiSelectFilter/MultiSelectFilter';
import { useCampaignsQuery } from '@hooks/queries/campaigns';

type CampaignsFilterProps = {
  onChange: (value: string[]) => void;
  selectedCampaignIds: string[];
};

export default memo(function CampaignsFilter({
  onChange,
  selectedCampaignIds
}: CampaignsFilterProps) {
  const [workspace] = useCurrentWorkspace();

  const {
    data: campaigns,
    isLoading: isLoadingCampaigns,
    hasNextPage: hasNextPageCampaigns,
    isFetchingNextPage: isFetchingNextPageCampaigns,
    fetchNextPage: fetchNextPageCampaigns
  } = useCampaignsQuery({
    workspaceId: workspace.id
  });

  const campaignsOptions = useMemo(() => {
    const campaignList =
      campaigns?.pages.flatMap((x) => x.edges.map((x) => x.node)) ?? [];
    return campaignList.map((item) => ({
      label: item.name,
      name: item.name,
      key: item.id
    }));
  }, [campaigns]);

  return (
    <MultiSelectFilter
      onChange={onChange}
      items={[
        {
          key: SHOW_ALL_KEY,
          name: 'Show all',
          label: 'Show all'
        },
        ...campaignsOptions
      ]}
      selectedKeys={selectedCampaignIds}
      hasMore={hasNextPageCampaigns}
      onLoadMore={fetchNextPageCampaigns}
      isLoadingMore={isLoadingCampaigns || isFetchingNextPageCampaigns}
      placeholder="Project"
    />
  );
});
